import { render } from "./SearchContent.vue?vue&type=template&id=06bccb9a&scoped=true"
import script from "./SearchContent.vue?vue&type=script&lang=js"
export * from "./SearchContent.vue?vue&type=script&lang=js"

import "./SearchContent.vue?vue&type=style&index=0&id=06bccb9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06bccb9a"],['__file',"src/containerss/SearchContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06bccb9a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06bccb9a', __exports__)) {
    api.reload('06bccb9a', __exports__)
  }
  
  module.hot.accept("./SearchContent.vue?vue&type=template&id=06bccb9a&scoped=true", () => {
    api.rerender('06bccb9a', render)
  })

}


export default __exports__